window.addEventListener('DOMContentLoaded', () => {
    // --- Touch-Geräte: Pfeile im Slider ausblenden ---
    const isTouch = matchMedia('(hover: none)').matches;
    const sliderWrapper = document.querySelector('.woo-variation-gallery-slider');
    if (sliderWrapper && isTouch) {
        sliderWrapper.querySelectorAll('.slick-arrow').forEach(arrow => arrow.style.display = 'none');
    }

    // --- Product Details Button ---
    const btnProductDetail = document.querySelector('.button__product-details');
    const productDetails = document.querySelector('.product-details');

    if (btnProductDetail && productDetails) {
        if (productDetails.childElementCount === 0) {
            btnProductDetail.style.display = 'none'; // Button ausblenden, wenn leer
        } else {
            const detailsOffsetTop = productDetails.offsetTop;
            btnProductDetail.addEventListener('click', () => {
                window.scrollTo({
                    top: detailsOffsetTop - 100,
                    behavior: 'smooth',
                });
            });
        }
    }

    // --- Accordion ---
    document.querySelectorAll('.accordion-block').forEach(block => {
        const title = block.querySelector('.accordion-title');
        const content = block.querySelector('.accordion-content');

        if (title && content) {
            const toggleAccordion = () => {
                title.classList.toggle('is-open');
                content.classList.toggle('is-open');
            };

            title.addEventListener('click', toggleAccordion);
            title.addEventListener('keypress', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleAccordion();
                }
            });
        }
    });

    // --- Add-Ons: Basispreis ausblenden ---
    const productContainer = document.querySelector('.singleproduct .cart');
    if (productContainer) {
        const hideBasePrice = () => {
            const addons = productContainer.querySelector('.wcpa_form_outer');
            if (addons) {
                const totalPrice = productContainer.querySelector('.bm-price-totals');
                if (totalPrice) totalPrice.style.display = 'none';
            }
        };

        hideBasePrice(); // Initial prüfen

        // MutationObserver, um DOM-Änderungen zu erkennen
        const observer = new MutationObserver(hideBasePrice);
        observer.observe(productContainer, { childList: true, subtree: true });
    }
});
